import Fade from '@material-ui/core/Fade';
import CurrentTabZeroActions from 'Modules/ActionsRewrite/components/tableTabs/zeroState/CurrentTabZeroActions';

import { Table } from '@clari/iris-table';
import React from 'react';
import { ActionComposeEnum } from '@groove/action-compose/constants';
import ActionCompose from '@groove/action-compose';
import useGetActionsInfinitely from 'Modules/ActionsRewrite/hooks/useGetActionsInfinitely';
import useBuildDefaultColumnOrder from 'Modules/ActionsRewrite/components/columnDefs/useBuildDefaultColumnOrder';
import useColumnDefinitionsBuilder from 'Modules/ActionsRewrite/components/columnDefs/useColumnDefinitionsBuilder';
import useStore from 'Modules/ActionsRewrite/store/useStore';
import LoadingTable from 'Modules/ActionsRewrite/components/LoadingTable';
import type { SortChangedEvent, Column } from '@ag-grid-community/core';

import '@clari/iris-react/style.css';
import '@clari/iris-table/style.css';

const ActionsTable: React.FC = () => {
  const defaultColumnOrder = useBuildDefaultColumnOrder();
  const columnDefinitionsBuilder =
    useColumnDefinitionsBuilder(defaultColumnOrder);
  const [order, setOrder] = React.useState(null);

  const { activeTab } = useStore();
  const {
    data: actionPages,
    fetchNextPage,
    isLoading,
  } = useGetActionsInfinitely(
    columnDefinitionsBuilder.columnsQueryKey,
    activeTab,
    order
  );
  const actions = actionPages?.pages?.flatMap(actionPage => actionPage.data);

  const handleSort = (sortModel: SortChangedEvent<Column<unknown>>) => {
    const sortData = sortModel.columns[sortModel.columns.length - 1];
    if (sortData) {
      const direction = sortData.sort;
      const field = sortData.colId;
      setOrder({ direction, field });
    } else {
      setOrder(null);
    }
  };

  const getColumnDefinitions = () => {
    return columnDefinitionsBuilder.columnDefinitions.map(column =>
      column.field === order?.field
        ? { ...column, sort: order.direction }
        : column
    );
  };

  return (
    <>
      <div className="flex-1 w-auto">
        {isLoading && <LoadingTable />}
        <Fade in={!isLoading} timeout={250}>
          {actions?.length ? (
            <Table
              onSortChanged={handleSort}
              loadingCellRenderer={() => <span>Loading</span>}
              id="iris-table-1"
              rowData={actions}
              loadingOverlayComponent={LoadingTable}
              suppressScrollOnNewData // To prevent jumping to the top upon receiving new data
              onBodyScrollEnd={event => {
                if (event.direction === 'vertical') fetchNextPage();
              }}
              defaultColDef={{
                cellStyle: params => ({
                  display: 'flex',
                  alignItems: 'center',
                }),
              }}
              suppressFieldDotNotation={false} // To enable accessing nested properties via `.`
              columnDefs={getColumnDefinitions()}
            />
          ) : (
            <CurrentTabZeroActions />
          )}
        </Fade>
      </div>
      <div className="absolute right-[50px] bottom-0 shadow-3xl">
        <ActionCompose showHeader initialState={ActionComposeEnum.MINIMIZED} />
      </div>
    </>
  );
};

export default ActionsTable;
